import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faPlug } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-battery-level-component',
  templateUrl: './battery-level-component.component.html',
  styleUrls: ['./battery-level-component.component.scss']
})
export class BatteryLevelComponentComponent {
  levelArr:any[]=["off", "off", "off", "off", "off"];
  bars = 5;
  faPlug=faPlug;
  batterystat = 0;
  @Input() showLevel=false;
  levelValue:number = 0;
  @Input() deviceName:any;
  @Input() deviceId:any;
  @Output() sendDatatoParent:EventEmitter<any> = new EventEmitter();
  @Input() set level(val:any){
    console.log(val);
    this.batterystat = val?.stat;
    if(val?.bars==5){
      const arr=["off", "off", "off", "off", "off"];
        if(val?.value){
          this.levelValue = +val?.value;
          let ceil = Math.ceil(+val?.value/20);  //20% is one bar
          for(let i=0; i<ceil; i++){
            arr[i]="on";
          }
          this.levelArr = arr;
        }else{
          this.levelArr=["off", "off", "off", "off", "off"];
          this.levelValue = 0;
        }
    }else if(val?.bars==10){
      const arr=["off", "off", "off", "off", "off","off", "off", "off", "off", "off"];
        if(val?.value){
          if(val?.value>90&&val?.value<100){
            this.levelValue = +val?.value;
            let ceil = Math.ceil(9);  //10% is one bar
            for(let i=0; i<ceil; i++){
              arr[i]="on";
            }
            this.levelArr = arr;
          }else{
            this.levelValue = +val?.value;
            let ceil = Math.ceil(+val?.value/10);  //10% is one bar
            for(let i=0; i<ceil; i++){
              arr[i]="on";
            }
            this.levelArr = arr;
          }
         
        }else{
          this.levelArr=["off", "off", "off", "off", "off","off", "off", "off", "off", "off"];
          this.levelValue = 0;
        }
    }

  }
  alert($event){
    console.log($event);
    this.sendDatatoParent.emit({string:'battery', id:this.deviceId, name:this.deviceName});
  }
}
